/**
 *
 * @Copyright 2024 UNLOCKIT DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

import {
    FieldValue,
    FormValidator,
    FormValidatorError,
    FormValidatorErrorType,
} from '../validations';

import { ValidatorStrategy } from './Validator';
import { stringToDecimal } from '../misc';

export class MaxValueValidator implements ValidatorStrategy {
    validate(fieldValue: FieldValue, validator: FormValidator): FormValidatorError | null {
        const {
            max,
        } = validator;
        // No error shown if user did not type anything yet
        if (fieldValue.toString().length === 0) return null;

        const decimalNumber = stringToDecimal(String(fieldValue));
        if (max && decimalNumber > max) {
            return {
                typeOfViolation: FormValidatorErrorType.Max,
                max,
            };
        }
        return null;
    }
}
